import { useEffect, useRef } from 'react';

// Similar to componentDidUpdate, but for function components.
export function useDidUpdateEffect(fn, inputs) {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) fn();
    else didMountRef.current = true;
  }, inputs);
}
